/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions,react/jsx-key */
import React, { Fragment } from 'react';
import {
  string,
  shape,
  func,
} from 'prop-types';
import {
  Heading,
  LazyLoadImg,
  Link,
} from 'components/common';
import { Query } from 'react-apollo';
import Layout from 'components/layout';
import { withTracking } from 'components/tracking';
import withApplicationConfig from 'containers/withApplicationConfig';
import ReactSlick from 'react-slick';

import GetSummerTravelPage from '../../queries/getSummerTravelPage.gql';
import AnchorTabsTW from './AnchorTabsTW';
import Share from '../../components/common/loadables/Share';
import './SummerTravelPage.scss';

const SummerTravelPage = ({
  language,
  localisation,
  track,
}) => {
  const settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    speed: 500,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 7000,
    slidesToShow: 3,
    slidesToScroll: 3,
    centerPadding: '50px',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          centerPadding: '100px',
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          centerPadding: '60px',
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          centerPadding: '50px',
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          centerPadding: '100px',
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '100px',
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '80px',
        },
      },
      {
        breakpoint: 374,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '50px',
        },
      },
    ],
  };

  const seoMetadata = {
    canonicalLink: 'https://www.money101.com.tw/夏日旅行者聯盟',
    image: {
      description: null,
      url: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt5e3e0432d4fe62ba/5d255553efd6391a8277defe/money101_share_img.png',
      alt: '夏日旅行者聯盟，現金回饋、機場接送、無腦刷信用卡｜Money101.com.tw',
    },
    metaDescription: '出國旅遊要辦哪一張信用卡？無論是重視海外現金回饋或是哩程累積、機場接送或貴賓室，又或是你需要的是一張無腦刷的信用卡？2分鐘讓你知道哪一張信用卡最適合你！參加夏日旅行者聯盟，月月抽沖繩機票雙人行！',
    metaTitle: '夏日旅行者聯盟，現金回饋、機場接送、無腦刷信用卡｜Money101.com.tw',
    pagination: {
      next: '',
      prev: '',
    },
    robotsMetaDirectives: 'index,follow',
    sitemap: true,
    title: '/夏日旅行者聯盟',
  };

  const campaignDetailList = [
    '如您已參與 《夏日旅行者聯盟》活動 ，即視為您已閱讀及同意本條款及細則約束。',
    '活動的參與者需符合a與b條款，否則活動參與資格將被取消。a.得獎者需為Money101.com.tw Facebook粉絲團粉絲。 b.參與者需年滿二十歲，且現居住地為台灣地區。',
    '於《夏日旅行者聯盟》活動頁面找出屬於自己的旅行英雄屬性，或是至Money101.com.tw LINE 帳號完成行為分析，找出適合你的旅遊神卡，點進我們幫你配對的神卡，看看他有什麼吸引你的優惠或回饋，將結果設定公開分享告訴小編並完成問卷，即取得抽獎資格。',
    '本活動自即日起至2019/8/31 23:59止',
    '獎項與數量：【沖繩來回機票2張】共計2名，抽獎日期為：7月 31日與 8月31日，各抽出一名。中獎公告將於8月2日與 9月2日公佈在Money101.com.tw 粉絲團，馬上成為Money101.com.tw Facebook粉絲團粉絲，得獎資訊不漏接！',
    '中獎者需配合主辦單位與執行單位簽認中獎確認書後始具有領獎資格。',
    '中獎幸運兒需於抽獎公告後 14 天內在FB私訊小編基本寄送資料 (中文全名、Email、連絡電話)，若未回覆者視同放棄！',
    '參與者需提供寄送獎品所需的相關個人資料，任何因電腦、網路等技術問題而引致參加者所遞交的資料有遲延、遺失、錯誤、無法辨識等情況，Money101.com.tw 概不負責。',
    '本活動所所收集之個人訊息僅限於活動贈品寄送使用，如提供相關個資即同意Money101.com.tw 蒐集之個人資訊(https://www.money101.com.tw/privacy-policy)。',
    '禁止遞交任何包含裸露、暴力、猥褻、粗俗、色情、涉及不法行為或任何帶攻擊性內容之字句。任何違規留言將一律予以刪除及取消參加資格。',
    '得獎者需完成所有列於活動規範的步驟，否則得獎資格會被取消 。',
    '獎項寄送僅限台灣地區，恕不寄送海外，主辦單位除本活動獎品外，不負擔其他費用；若放棄領獎，恕無折抵方案。',
    '本活動得獎者不得要求以獎品換取獎金或轉換其他等值商品。機票開立後，不可轉讓其它航空公司、不可轉讓他人使用。 機票不含燃油附加稅金、護照、簽證辦理工本費、個人私人消費、座艙升等、加人費用。機票逢特殊節日、國定假日、連續假期、寒暑假、航空公司波段售價調整等區間均不適用，需另外加價(價格依航空公司規定)，詳細規範以兌換券上載明為主。本兌換券須壹次使用完畢，不得分次使用或兌現及找零。',
    '依中華民國財政部國稅局各類所得扣繳率標準（2000 年 12 月 22 日 修正）規定：競技競賽機會中獎獎金或給付均須列單申報該管稽徵機關。本活動所有獎項，將會依稅法規定於年度開立扣繳憑單予活動中獎者，屆時中獎人可憑扣繳憑單之扣繳稅額抵減個人綜合所得稅。另，年度累積中獎價值若超過新臺幣1,000元整，應列入中獎人年度綜合所得；中獎金額或獎項價值超過NT$ 20,000 元整，依法應預扣繳 10% 稅金（非中華民國境內居住之個人，依法扣繳 20% 稅金）；得獎者需依法先繳納稅額，若未繳交稅金視同放棄得獎資格。相關扣繳資訊，請參閱：各類所得扣繳率標準（http://law.moj.gov.tw/LawClass/LawAll.aspx?PCode=G0340028）。',
    '得獎人之FB 帳號需為真實身分，不得為人頭帳號、假帳號，若得獎人以人頭帳號或電腦駭客程式等不正當之手段參與活動，經主辦單位發現或經第三人檢舉，則主辦單位有權取消使用者之參與、得獎資格，主辦單位不另行通知，並保留法律追訴權。有機器灌水與相關惡意參與行為，相同 id（包含 ip 位置）來源的申請紀錄將取消抽獎資格。',
    '對於活動如有任何爭議，Money101.com.tw 保留最終決定權，包括隨時暫停、轉變、更改或終止比賽及其條款及細則，而毋須另行通知。',
    '本活動如有未盡事宜，主辦單位將另行公告之。',
  ];

  const heroList = [
    {
      id: '神算超人',
      imgUrl: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blta6c03236fdd417d8/5d4159eceb241003ac3319f1/hero_1.png',
      tabletImgUrl: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt75c4d15d6c3e9310/5d42bbedeb241003ac332387/hero_1_tablet.png',
      share: {
        provider: 'facebook',
        shareParam: {
          url: 'https://www.money101.com.tw/夏日旅行者聯盟',
          hash_tags: '#Money101夏日旅行者聯盟送你遊沖繩',
        },
      },
      cardList: [
        {
          name: '彰化銀行 My樂現金回饋卡',
          id: 'TW.CC.CHBX0004.彰化銀行 My樂現金回饋卡',
          price: '',
          currency: '',
          brand: '彰化銀行',
          category: 'CreditCard',
          purchaseIntent: 'apply',
          position: 1,
          img: {
            alt: '彰化銀行 My樂現金回饋卡',
            imgName: 'chbx_card.png',
            imgUrl: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt359d578c109b7845/5d4159dda25e75043a7d8db2/chbx_card.png',
            srcset: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt8fa94ca321938800/5d4159df6380a83d9b8cd4bd/chbx_card_tablet.png',
          },
          href: 'https://ad.doubleclick.net/ddm/trackclk/N195002.2138303MONEY101.COM.TW/B9966447.251966526;dc_trk_aid=447893766;dc_trk_cid=71947843;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        },
        {
          name: '王道銀行 簽帳金融卡',
          id: 'TW.CC.OBKX0001.王道銀行 簽帳金融卡',
          price: '',
          currency: '',
          brand: '王道銀行',
          category: 'CreditCard',
          purchaseIntent: 'apply',
          position: 2,
          img: {
            alt: '王道銀行 簽帳金融卡',
            imgName: 'obank_card.png',
            imgUrl: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt99e2bf6194c7ad1e/5d4159f8552a8c394ccc82a5/obank_card.png',
            srcset: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt62ab8591cee1d57f/5d4159f848143c39c4b3dc92/obank_card_tablet.png',
          },
          href: 'https://ad.doubleclick.net/ddm/trackclk/N195002.2138303MONEY101.COM.TW/B9966447.222880614;dc_trk_aid=421091152;dc_trk_cid=71947843;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        },
        {
          name: '花旗銀行 現金回饋PLUS卡',
          id: 'TW.CC.CITI0011.花旗銀行 現金回饋PLUS卡',
          price: '',
          currency: '',
          brand: '花旗銀行',
          category: 'CreditCard',
          purchaseIntent: 'apply',
          position: 3,
          img: {
            alt: '花旗銀行 現金回饋PLUS卡',
            imgName: 'citi_card.png',
            imgUrl: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltb35f7b9684e3ad06/5d4159df17e47e0445545c46/citi_card.png',
            srcset: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltc8563e86de34a6a2/5d4159df552a8c394ccc829f/citi_card_tablet.png',
          },
          href: 'https://ad.doubleclick.net/ddm/trackclk/N195002.2138303MONEY101.COM.TW/B9966447.141655161;dc_trk_aid=319476063;dc_trk_cid=71947843;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        },
      ],
    },
    {
      id: '奇異碩士',
      imgUrl: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt01ef514a18c38ad7/5d425ad048143c39c4b3e2b5/hero_2.png',
      tabletImgUrl: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt7325e40614164d3a/5d42bbd3e6adda03a744fc19/hero_2_tablet.png',
      share: {
        provider: 'facebook',
        shareParam: {
          url: 'https://www.money101.com.tw/夏日旅行者聯盟',
          quote: '我是奇異碩士',
        },
      },
      cardList: [
        {
          name: '台灣樂天 樂天信用卡',
          id: 'TW.CC.RKUX0001.台灣樂天 樂天信用卡',
          price: '',
          currency: '',
          brand: '台灣樂天',
          category: 'CreditCard',
          purchaseIntent: 'apply',
          position: 4,
          img: {
            alt: '台灣樂天 樂天信用卡',
            imgName: 'rakuten_card.png',
            imgUrl: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt13d6947d7cc91366/5d4159f85cd7063da0020ad7/rakuten_card.png',
            srcset: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltaba64e4ba21f274d/5d4159f848143c39c4b3dc98/rakuten_card_tablet.png',
          },
          href: 'https://ad.doubleclick.net/ddm/trackclk/N195002.2138303MONEY101.COM.TW/B9966447.250520678;dc_trk_aid=446951441;dc_trk_cid=71947843;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        },
        {
          name: '國泰世華 亞洲萬里通聯名世界卡',
          id: 'TW.CC.CUBX0021.國泰世華 亞洲萬里通聯名世界卡',
          price: '',
          currency: '',
          brand: '國泰世華',
          category: 'CreditCard',
          purchaseIntent: 'apply',
          position: 5,
          img: {
            alt: '國泰世華 亞洲萬里通聯名世界卡',
            imgName: 'cubx_card.png',
            imgUrl: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltce50d97ab61cb596/5d4159dfb0a4c13e22988375/cubx_card.png',
            srcset: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt95b479b8f4f06750/5d4159df3d6fea39476158cb/cubx_card_tablet.png',
          },
          href: 'https://ad.doubleclick.net/ddm/trackclk/N195002.2138303MONEY101.COM.TW/B9966447.138460697;dc_trk_aid=422489698;dc_trk_cid=71947843;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        },
        {
          name: '滙豐銀行 中華航空聯名無限卡',
          id: 'TW.CC.HSBC0005.滙豐銀行 中華航空聯名無限卡',
          price: '',
          currency: '',
          brand: '滙豐銀行',
          category: 'CreditCard',
          purchaseIntent: 'apply',
          position: 6,
          img: {
            alt: '滙豐銀行 中華航空聯名無限卡',
            imgName: 'hsbc_card_1.png',
            imgUrl: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt4e3c2a91e4dad4fe/5d4159ec17e47e0445545c4c/hsbc_card_1.png',
            srcset: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltc4b5c21722358638/5d4159eca15cf339be7e5087/hsbc_card_1_tablet.png',
          },
          href: 'https://ad.doubleclick.net/ddm/trackclk/N195002.2138303MONEY101.COM.TW/B9966447.138467430;dc_trk_aid=402780054;dc_trk_cid=71947843;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=',
        },
      ],
    },
    {
      id: '美濃隊長',
      imgUrl: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltce46debffd3b1d42/5d425af3552a8c394ccc89bb/hero_3.png',
      tabletImgUrl: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltbb1f3182136a246c/5d42bbb4a25e75043a7d9707/hero_3_tablet.png',
      share: {
        provider: 'facebook',
        shareParam: {
          url: 'https://www.money101.com.tw/夏日旅行者聯盟',
          hash_tags: '#Money101夏日旅行者聯盟送你遊沖繩',
          quote: '我是美濃隊長',
        },
      },
      cardList: [
        {
          name: '滙豐銀行 現金回饋御璽卡',
          id: 'TW.CC.HSBC0004.滙豐銀行 現金回饋御璽卡',
          price: '',
          currency: '',
          brand: '滙豐銀行',
          category: 'CreditCard',
          purchaseIntent: 'apply',
          position: 7,
          img: {
            alt: '滙豐銀行 現金回饋御璽卡',
            imgName: 'hsbc_card.png',
            imgUrl: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt223f3e9602302887/5d4159ecf371693e1cb23cb4/hsbc_card.png',
            srcset: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt5518217ac534dc3b/5d4159eca25e75043a7d8db8/hsbc_card_tablet.png',
          },
          href: 'https://ad.doubleclick.net/ddm/trackclk/N195002.2138303MONEY101.COM.TW/B9966447.138467430;dc_trk_aid=310781197;dc_trk_cid=71947843;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=',
        },
        {
          name: '台新銀行 FlyGo卡',
          id: 'TW.CC.TAIS0024.台新銀行 FLYGO卡',
          price: '',
          currency: '',
          brand: '台新銀行',
          category: 'CreditCard',
          purchaseIntent: 'apply',
          position: 8,
          img: {
            alt: '台新銀行 FlyGo卡',
            imgName: 'tais_card.png',
            imgUrl: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltb3c74895821a0c4c/5d4159ffb0a4c13e22988389/tais_card.png',
            srcset: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltc9196fa7e6c3ca79/5d4159ff17e47e0445545c5e/tais_card_tablet.png',
          },
          href: 'https://ad.doubleclick.net/ddm/trackclk/N195002.2138303MONEY101.COM.TW/B9966447.144490160;dc_trk_aid=447796759;dc_trk_cid=71947843;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        },
        {
          name: '星展銀行 飛行世界卡',
          id: 'TW.CC.DBSX0004.星展銀行 飛行世界卡',
          price: '',
          currency: '',
          brand: '星展銀行',
          category: 'CreditCard',
          purchaseIntent: 'apply',
          position: 9,
          img: {
            alt: '星展銀行 飛行世界卡',
            imgName: 'dbs_card.png',
            imgUrl: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt8b9d3ac7fc8ce71b/5d4159df5cd7063da0020acb/dbs_card.png',
            srcset: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltfc0e7d12fa6de13f/5d4159dff371693e1cb23cae/dbs_card_tablet.png',
          },
          href: 'https://ad.doubleclick.net/ddm/trackclk/N195002.2138303MONEY101.COM.TW/B9966447.223416337;dc_trk_aid=421645710;dc_trk_cid=71947843;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        },
      ],
    },
  ];

  /* Tracking */
  const onCampaignApplyButtonClick = (pageName, cardData) => {
    const verticalCode = {
      ecommerce: {
        click: {
          products: [{
            name: cardData.name,
            id: cardData.id,
            price: '',
            currency: '',
            brand: cardData.brand,
            category: 'CreditCard',
            purchaseIntent: 'apply',
            position: cardData.position,
          }],
          actionField: {
            list: pageName,
          },
        },
      },
      event: 'productClick',
    };
    const win = window.open(`/external?url=${cardData.href}`, '_blank');
    win.focus();
    track({ data: verticalCode });
  };

  return (
    <Query
      query={GetSummerTravelPage}
      variables={{
        language: localisation[language],
        staticTextKeys: [],
        product: '加入我們',
      }}
    >
      {({ loading, data }) => (
        <Layout {...data.pageConfig} seoMetadata={seoMetadata}>
          {loading
            || (
              <AnchorTabsTW
                  tabs={[{
                    src: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt7f40cb6a09446b05/5d1af6478133924e8c7dae23/nav_img_1.png',
                    srctablet: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt7dda4baa7af7ffb9/5d2fcdfdb66c7c42e5d30507/nav_img_1_tablet.png',
                  },
                  {
                    src: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt308188185bca698a/5d1af647a3e03652eee9fe3a/nav_img_2.png',
                    srctablet: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blta82756295a3a6e30/5d2eef406e35534256b3097d/nav_img_2_tablet.png',
                  },
                  {
                    src: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt736fd443dfc62942/5d1af647d5b90b52eb387de4/nav_img_3.png',
                    srctablet: 'https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt81afcf52eae0d713/5d2eef40c2ae05425741713d/nav_img_3_tablet.png',
                  },
                  ]}
                >
                  <div className="summer-travel-main">
                    <LazyLoadImg
                      className="full-image campaign-mobile"
                      src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltaee6a97021ae9a6d/5d1f0b368bcda8163689bfb5/main.png"
                    />
                    <span className="hero-test-content campaign-tablet">
                      <LazyLoadImg
                        className="full-image campaign-tablet"
                        src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt3c3efde096cc01b0/5d2d439afcfd4e7474c5cdd0/main_tablet.png"
                      />
                      <Link
                        className="hero-test-tablet"
                        to="https://line.me/R/ti/p/%40rej1041q"
                      >
                        <LazyLoadImg
                          className="full-image campaign-tablet"
                          src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt48d7c4bd396f3f78/5d2d6d228f87147b031e304e/hero_test_tablet.png"
                        />
                      </Link>
                    </span>
                    <div className="layout-container container main-text-content">
                      <div className="layout-row">
                        <div className="layout-column column-xs-8 column-sm-9 column-md-8 offset-md-2">
                          透過你的行為分析，找出適合你的旅遊神卡，請你
                          <span className="red">點進我們幫你配對的神卡</span>
                          ，看看他有什麼吸引你的優惠或回饋，然後記得一定要公開分享告訴小編並完成問卷，
                          就有機會抽中沖繩來回機票。月月抽機票，一人中獎二人同行，越早參加中獎機會越大！
                        </div>
                        <div className="layout-column column-xs-4 column-sm-3 right link-anchor campaign-mobile">
                          <Link to="https://line.me/R/ti/p/%40rej1041q">
                            <LazyLoadImg
                              className="full-image"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltaaa6cbc01e99531d/5d2c406cf22cf073ebc2a70e/hero_test.png"
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="layout-container container step-content">
                    <div className="layout-row step-row-content">
                      <Link
                        className="item-center link-anchor"
                        to="#神算超人"
                      >
                        <LazyLoadImg
                          className="campaign-mobile"
                          src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt1cb5a45194fe867a/5d4159f8a25e75043a7d8dbe/step_1.png"
                        />
                        <LazyLoadImg
                          className="step-icon campaign-tablet"
                          src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt66b56edb7105fd2e/5d4159f817e47e0445545c58/step_1_tablet.png"
                        />
                      </Link>
                      <Share
                        classes="item-center link-anchor"
                        provider="facebook"
                        shareParam={{
                          url: 'https://www.money101.com.tw/夏日旅行者聯盟',
                          hash_tags: '#Money101夏日旅行者聯盟送你遊沖繩',
                          quote: '旅行神卡在這裏',
                        }}
                      >
                        <LazyLoadImg
                          className="campaign-mobile"
                          src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt95a8dd8f7561a4ca/5d4159f8f371693e1cb23cba/step_2.png"
                        />
                        <LazyLoadImg
                          className="step-icon campaign-tablet"
                          src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blta6b9b696a4e5e3f2/5d4159f83d6fea39476158d7/step_2_tablet.png"
                        />
                      </Share>
                      <Link
                        className="item-center link-anchor"
                        to="#登錄問卷"
                      >
                        <LazyLoadImg
                          className="campaign-mobile"
                          src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltfb4760fbf3c4f2f9/5d4159f8eb241003ac3319f7/step_3.png"
                        />
                        <LazyLoadImg
                          className="step-icon campaign-tablet"
                          src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltd24eb21bae4bc5f4/5d4159f8a15cf339be7e508d/step_3_tablet.png"
                        />
                      </Link>
                    </div>
                  </div>
                  <div
                    isTabPanel={true}
                    className="hero-content"
                  >
                    {
                      heroList.map(heroData => (
                        <>
                          <span id={heroData.id}>
                            <LazyLoadImg
                              className="full-image campaign-mobile"
                              src={heroData.imgUrl}
                            />
                            <LazyLoadImg
                              className="full-image campaign-tablet"
                              src={heroData.tabletImgUrl}
                            />
                          </span>
                          <div className="container divide-content campaign-mobile">
                            <div className="layout-row">
                              <div className="layout-column column-xs-12 item-center">
                                <Share
                                  provider={heroData.share.provider}
                                  shareParam={heroData.share.shareParam}
                                >
                                  <LazyLoadImg src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt10646ac2f0064a36/5d2c45118f87147b031e2a65/share.png" />
                                </Share>
                              </div>
                            </div>
                          </div>
                          <div className="container divide-content campaign-mobile">
                            <div className="layout-row">
                              <div className="layout-column column-xs-12 item-center">
                                <LazyLoadImg src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt3dbd7d8f0f45f786/5d1b184d5f304656c2ba8595/divide_line.png" />
                              </div>
                            </div>
                          </div>
                          <div className="slide-content">
                            <ReactSlick {...settings}>
                              {heroData.cardList.map(cardData => (
                                <div className="slide-item">
                                  <picture>
                                    <source media="(min-width: 769px)" srcSet={cardData.img.srcset} />
                                    <source media="(max-width: 768px)" srcSet={cardData.img.imgUrl} />
                                    <img style={{ width: '90%' }} alt={cardData.img.alt} src={cardData.img.imgUrl} />
                                  </picture>
                                  <span
                                    className="apply-btn"
                                    onClick={() => onCampaignApplyButtonClick('campaign', cardData)}
                                  >
                                    <img
                                      alt="apply-btn"
                                      className="campaign-mobile"
                                      src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt7f44165d3cd65b82/5d42b20deb241003ac3322af/apply_btn.png"
                                    />
                                    <img
                                      alt="apply-btn"
                                      className="campaign-tablet"
                                      src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt65ac54ce0346bf7a/5d42b1edf371693e1cb24567/apply_btn_tablet.png"
                                    />
                                  </span>
                                </div>
                              ))}
                            </ReactSlick>
                          </div>
                          <div className="layout-container container share-content campaign-tablet">
                            <div className="layout-row">
                              <div className="layout-column column-md-6 offset-md-3 item-center">
                                <Share
                                  classes="full-image"
                                  provider={heroData.share.provider}
                                  shareParam={heroData.share.shareParam}
                                >
                                  <LazyLoadImg
                                    className="full-image"
                                    src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blte73c00812c09bf4b/5d2d80c78e6f797b0da30589/share_tablet.png"
                                  />
                                </Share>
                              </div>
                            </div>
                          </div>
                        </>
                      ))
                    }
                  </div>
                  <div isTabPanel={true} className="strategy-content">
                    <LazyLoadImg
                      className="full-image strategy-bk-img campaign-mobile"
                      src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltb919cc23f947ccea/5d1c63b9a3e03652eeea0948/strategy_bk.png"
                    />
                    <LazyLoadImg
                      className="full-image strategy-bk-img campaign-tablet"
                      src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt75eb8dacca1b6c50/5d2d95bcb3c3b6032396a664/strategy_bk_tablet.png"
                    />
                    <div className="strategy-items-content layout-container item-center">
                      <div className="layout-row">
                        <div className="layout-column column-xs-12 column-md-4 offset-md-1 strategy-item">
                          <Link
                            className="item-center"
                            to="https://www.money101.com.tw/blog/%E6%97%85%E9%81%8A%E5%B9%B3%E5%AE%89%E9%9A%AA-%E6%97%85%E9%81%8A%E4%B8%8D%E4%BE%BF%E9%9A%AA-%E6%97%85%E5%B9%B3%E9%9A%AA-%E4%BF%A1%E7%94%A8%E5%8D%A1-%E5%88%B7%E5%8D%A1?from=campaign"
                          >
                            <LazyLoadImg
                              className="campaign-mobile"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blte1ba4ec4d7b88ae9/5d1f1f1c8d27ea11c38210e6/travel_insurance_btn.png"
                            />
                            <LazyLoadImg
                              className="campaign-tablet full-image"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt1c52bbffcfc8392b/5d2d95bae105427a75b93ec6/travel_insurance_btn_tablet.png"
                            />
                          </Link>
                        </div>
                        <div className="layout-column column-xs-12 column-md-4 offset-md-2 strategy-item">
                          <Link
                            className="item-center"
                            to="https://www.money101.com.tw/blog/%E5%90%84%E5%AE%B6%E9%8A%80%E8%A1%8C-%E5%85%8D%E8%B2%BB%E6%A9%9F%E5%A0%B4%E6%8E%A5%E9%80%81-%E4%BF%A1%E7%94%A8%E5%8D%A1-%E6%95%B4%E7%90%86-2018?from=campaign"
                          >
                            <LazyLoadImg
                              className="campaign-mobile"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltea71fac07a83d17d/5d255a6c35718e163be53269/airport_pick_up_btn.png"
                            />
                            <LazyLoadImg
                              className="campaign-tablet full-image"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt2c24a1513eacb94c/5d2d95baf22cf073ebc2afa5/airport_pick_up_btn_tablet.png"
                            />
                          </Link>
                        </div>
                        <div className="layout-column column-xs-12 column-md-4 offset-md-1 strategy-item">
                          <Link
                            className="item-center"
                            to="https://www.money101.com.tw/blog/%E4%BF%A1%E7%94%A8%E5%8D%A1-%E6%A1%83%E6%A9%9F-%E5%8F%B0%E4%B8%AD-%E9%AB%98%E9%9B%84-%E6%A9%9F%E5%A0%B4-%E5%85%8D%E8%B2%BB%E5%81%9C%E8%BB%8A-%E5%87%BA%E5%9C%8B%E5%81%9C%E8%BB%8A?from=campaign"
                          >
                            <LazyLoadImg
                              className="campaign-mobile"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltd4bab90d4ccca679/5d1f1f8d45708516c98953c7/airport_parkiing_btn.png"
                            />
                            <LazyLoadImg
                              className="campaign-tablet full-image"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt7b982398da3ff327/5d2d95b90036537a7aac4349/airport_parkiing_btn_tablet.png"
                            />
                          </Link>
                        </div>
                        <div className="layout-column column-xs-12 column-md-4 offset-md-2 strategy-item">
                          <Link
                            className="item-center"
                            to="https://www.money101.com.tw/blog/%E6%97%85%E9%81%8A%E5%A5%BD%E5%B9%AB%E6%89%8B%EF%BC%81wifi-%E5%88%86%E4%BA%AB%E5%99%A8%E9%80%99%E6%A8%A3%E7%A7%9F%E7%9C%81%E6%9B%B4%E5%A4%9A%EF%BC%81?from=campaign"
                          >
                            <LazyLoadImg
                              className="campaign-mobile"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt19b70fedfb7102af/5d255ab0414f3b16bf82a456/internet_oversea_btn.png"
                            />
                            <LazyLoadImg
                              className="campaign-tablet full-image"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt0118745b95d29647/5d2d95ba8e6f797b0da306bc/internet_oversea_btn_tablet.png"
                            />
                          </Link>
                        </div>
                        <div className="layout-column column-xs-12 column-md-4 offset-md-1 strategy-item">
                          <Link
                            className="item-center"
                            to="https://www.money101.com.tw/blog/%E3%80%902017%E4%BF%A1%E7%94%A8%E5%8D%A1%E7%B3%BB%E5%88%97%E3%80%91%E5%85%8D%E8%B2%BB%E6%A9%9F%E5%A0%B4%E8%B2%B4%E8%B3%93%E5%AE%A4%E5%9C%A8%E6%AD%A4?from=campaign"
                          >
                            <LazyLoadImg
                              className="campaign-mobile"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt23736da5450ef4f7/5d1f1f6445708516c98953c3/airport_vip_room_btn.png"
                            />
                            <LazyLoadImg
                              className="campaign-tablet full-image"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltc5855d739cef8085/5d2d95ba8f87147b031e326e/airport_vip_room_btn_tablet.png"
                            />
                          </Link>
                        </div>
                        <div className="layout-column column-xs-12 column-md-4 offset-md-2 strategy-item">
                          <Link
                            className="item-center"
                            to="https://www.money101.com.tw/blog/%e5%87%ba%e5%9c%8b-%e5%bf%85%e5%82%99-%e8%a1%8c%e6%9d%8e%e6%b8%85%e5%96%ae-%e8%a1%8c%e6%9d%8e%e8%a6%8f%e5%ae%9a-%e8%a1%8c%e6%9d%8e-%e6%97%85%e9%81%8a?from=campaign"
                          >
                            <LazyLoadImg
                              className="campaign-mobile"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt2bda85ef87eb0013/5d255a9935718e163be5326d/travel_check_list_btn.png"
                            />
                            <LazyLoadImg
                              className="campaign-tablet full-image"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltc87b649563e79a5a/5d2d95baf22cf073ebc2afab/travel_check_list_btn_tablet.png"
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div isTabPanel={true} className="steps-content" id="登錄問卷">
                    <LazyLoadImg
                      className="full-image campaign-mobile"
                      src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltd1cfe078265eb764/5d1c634d8133924e8c7dba7f/title_bk.png"
                    />
                    <LazyLoadImg
                      className="full-image campaign-tablet title-bk"
                      src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt9b6fe7cacdc34759/5d2d9b920036537a7aac43bd/title_bk_tablet.png"
                    />
                    <div className="layout-container container">
                      <div className="layout-row">
                        <div className="layout-column column-xs-12 title campaign-mobile">
                          <LazyLoadImg src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blta5a117d248db3ff1/5d1c1ec25d8a9a536d15f5b3/campaign_detail_title.png" />
                        </div>
                        <div className="layout-column column-xs-10 offset-xs-1 step-text">
                          <Heading className="campaign-mobile" as="h3">分享你是哪種旅行英雄就有機會抽中沖繩來回機票！</Heading>
                          <Heading className="campaign-tablet" as="h1">分享你是哪種旅行英雄就有機會抽中沖繩來回機票！</Heading>
                        </div>
                        <div className="layout-column step-row-content">
                          <Link
                            className="item-center"
                            to="#神算超人"
                          >
                            <LazyLoadImg
                              className="campaign-mobile"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt1cb5a45194fe867a/5d4159f8a25e75043a7d8dbe/step_1.png"
                            />
                            <LazyLoadImg
                              className="step-icon campaign-tablet"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt66b56edb7105fd2e/5d4159f817e47e0445545c58/step_1_tablet.png"
                            />
                          </Link>
                          <Share
                            classes="item-center"
                            provider="facebook"
                            shareParam={{
                              url: 'https://www.money101.com.tw/夏日旅行者聯盟',
                              hash_tags: '#Money101夏日旅行者聯盟送你遊沖繩',
                              quote: '旅行神卡在這裏',
                            }}
                          >
                            <LazyLoadImg
                              className="campaign-mobile"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blt95a8dd8f7561a4ca/5d4159f8f371693e1cb23cba/step_2.png"
                            />
                            <LazyLoadImg
                              className="step-icon campaign-tablet"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/blta6b9b696a4e5e3f2/5d4159f83d6fea39476158d7/step_2_tablet.png"
                            />
                          </Share>
                          <Link
                            className="item-center"
                            to="#登錄問卷"
                          >
                            <LazyLoadImg
                              className="campaign-mobile"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltfb4760fbf3c4f2f9/5d4159f8eb241003ac3319f7/step_3.png"
                            />
                            <LazyLoadImg
                              className="step-icon campaign-tablet"
                              src="https://images.contentstack.io/v3/assets/blt4ca32b8be67c85f8/bltd24eb21bae4bc5f4/5d4159f8a15cf339be7e508d/step_3_tablet.png"
                            />
                          </Link>
                        </div>
                        <div className="layout-column column-xs-10 offset-xs-1 survey-monkey">
                          <div className="smcx-widget smcx-embed smcx-show smcx-widget-dark">
                            <div className="smcx-iframe-container">
                              <iframe
                                title="survey-monkey"
                                width="100%"
                                height="100%"
                                frameBorder="0"
                                allowTransparency="true"
                                src="https://www.surveymonkey.com/r/ZGFPMBV?embedded=1"
                              >
                                &nbsp;
                              </iframe>
                            </div>
                          </div>
                        </div>
                        <div className="layout-column column-xs-10 offset-xs-1 steps-content-title">
                          <Heading as="h2">活動規則與細項</Heading>
                        </div>
                        <div className="layout-column column-xs-10 offset-xs-1 steps-content-list">
                          <ol>
                            {
                              campaignDetailList.map(item => <li>{item}</li>)
                            }
                          </ol>
                        </div>
                      </div>
                    </div>
                  </div>
                </AnchorTabsTW>
            )
          }
        </Layout>
      )
      }
    </Query>
  );
};

SummerTravelPage.propTypes = {
  match: shape({}).isRequired,
  localisation: shape({}).isRequired,
  language: string.isRequired,
  track: func,
};

SummerTravelPage.defaultProps = {};

export default withTracking(withApplicationConfig(SummerTravelPage, ['languages']));
